<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const assessmentId = field<string>("assessmentId", "");
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:user-round-check" accent="reporting">
    <EditorField :label="t('assessmentIdLabel')" :hint="t('assessmentIdHint')">
      <Input v-model="assessmentId" class="h-8 rounded-sm bg-muted text-[13px]" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "User Selection"
  assessmentIdLabel: "Assessment ID"
  assessmentIdHint: "Only users from this assessment are shown in the selector."
</i18n>
